<template>
  <div
    v-if="!isEmptyData(items) && hasValidColumns"
    class="cal-fltl-table orders"
    ref="fltl"
    @click="handleCellClick"
  >
    <e-table
      name="calltl"
      :items="items"
      :virtual="virtual"
      :rowClass="rowClass"
      :cellClass="cellClass"
      :highlight="{ hover: false, click: true }"
      :coreColumnDefs="columnDefs"
      :columnOptions="columnOptions"
      :columnEvent="columnEvent"
      :maxHeight="maxHeight"
      :getHeight="getHeight"
      :bufferScale="bufferScale"
      @contextmenu="contextMenu.trigger"
    />

    <e-contextmenu
      ref="contextmenu"
      :target="$refs.fltl"
      :options="contextMenu.options"
      @handle="contextMenu.handle"
    />
  </div>
</template>
<script>
import api from "@/default/utils/api";
import "@/default/pages/containers/calendar/cells/fltl.js";
import "@/default/pages/containers/shared/shared.js";

export default {
  name: "ContainerCalendarFltl",
  mixins: [api],
  props: {
    mark: {
      type: String,
      required: true,
    },
    hubId: {
      type: Number,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    virtual: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLegacy: null,
      contextMenu: {
        options: [
          {
            type: "SEPARATOR",
          },
          {
            label: "View Order",
            type: "view-order",
          },
          {
            label: "Edit Order",
            type: "edit-order",
          },
        ],
        trigger: (row, rowIndex, event) => {
          this.$refs.contextmenu.trigger(row, rowIndex, event);
        },
        handle: (type, row) => {
          switch (type) {
            case "view-order":
              Dialog.open({
                width: "900px",
                title: "Container: " + row.id,
                url: "/containers/" + row.id,
              });
              break;
            case "edit-order":
              Dialog.open({
                width: "900px",
                title: "Edit Container: " + row.id,
                url: "/containers/" + row.id + "/edit",
              });
              break;
          }
        },
      },
      coreColumnDefs: [
        {
          title: "ID",
          field: "id",
          key: "id",
          width: 90,
          minWidth: 90,
          fixed: "left",
          classes: "cell-style",
          component: "fltl-id",
        },
        {
          title: "Action",
          key: "action",
          width: 72,
          minWidth: 72,
          fixed: "left",
          classes: "cell-style",
          component: "fltl-action",
        },
        {
          title: "Customers",
          field: "customers[0].name",
          key: "name",
          width: 120,
          component: "fltl-customers",
        },
        {
          title: "Operations",
          field: "truckers[0].name",
          key: "operations",
          width: 240,
          minWidth: 240,
          legacy: false,
          component: "container-routes",
        },
        {
          title: "Operations",
          field: "truckers[0].name",
          key: "operations",
          width: 325,
          minWidth: 325,
          legacy: true,
          component: "legacy-routes",
        },
        {
          title: "Route EST",
          field: "route_est",
          key: "route_est",
          width: 80,
          minWidth: 80,
          legacy: false,
          classes: "cell-style",
          component: "route-est",
        },
        {
          title: "Route Status",
          field: "route.name",
          key: "route_status",
          width: 150,
          minWidth: 150,
          legacy: false,
          classes: "cell-style tight",
          component: "route-status",
        },
        {
          title: "Instructions",
          field: "instructions",
          key: "instructions",
          width: 150,
          minWidth: 150,
          legacy: false,
          component: "drayage-instructions",
        },
        {
          title: "AR",
          field: "charges.receivable",
          key: "ar",
          width: 75,
          minWidth: 75,
          aliasName: "Accts. Receivable",
          component: "fltl-ar",
        },
        {
          title: "AP",
          field: "charges.payable",
          key: "ap",
          width: 75,
          minWidth: 75,
          aliasName: "Accts. Payable",
          component: "fltl-ap",
        },
        {
          title: "Profit",
          field: "charges.profit",
          key: "profit",
          width: 75,
          minWidth: 75,
          component: "fltl-profit",
        },
        {
          title: "CONT.#",
          field: "container_no",
          key: "container_no",
          width: 100,
          classes: "cell-style",
          component: "ve-table-column",
        },
        {
          title: "Type",
          field: "ctype",
          key: "ctype",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "Appt. Time",
          field: "appointment",
          key: "appt",
          width: 135,
          minWidth: 135,
          component: "appt-time",
        },
        {
          title: "PRI",
          field: "priority.value",
          key: "pri",
          width: 40,
          aliasName: "Priority",
          classes: "cell-style",
          component: "fltl-priority",
        },
        {
          title: "HAZ",
          field: "haz_cargo",
          key: "haz",
          width: 38,
          classes: "cell-style",
          component: "fltl-haz",
        },
        {
          title: "REF.#",
          field: "reference_no",
          key: "reference_no",
          width: 110,
          component: "ve-table-column",
        },
        {
          title: "Chassis#",
          field: "chassis_no",
          key: "chassis_no",
          width: 100,
          component: "ve-table-column",
        },
        {
          title: "LFD",
          field: "lfd",
          key: "lfd",
          path: "lfd_fmt",
          width: 90,
          minWidth: 90,
          classes: "cell-style tight",
          component: "fltl-lfd",
        },
        {
          title: "Origin",
          path: "origins[0].name",
          key: "origin",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "ORI. Street",
          path: "origins[0].street",
          key: "ori_street",
          width: 100,
          component: "ve-table-column",
        },
        {
          title: "ORI. City",
          path: "origins[0].city",
          key: "ori_city",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "ORI. ST",
          path: "origins[0].state",
          key: "ori_state",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "Destination",
          path: "destinations[0].name",
          key: "dest",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "DEST. Street",
          path: "destinations[0].street",
          key: "dest_street",
          width: 100,
          component: "ve-table-column",
        },
        {
          title: "DEST. City",
          path: "destinations[0].city",
          key: "dest_city",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "DEST. ST",
          path: "destinations[0].state",
          key: "dest_state",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "Dispatch",
          field: "dispatch_comment",
          key: "dispatch_comment",
          width: 125,
          classes: "cell-style tight",
          component: "fltl-dispatch-comment",
        },
        {
          title: "Tasks",
          key: "tasks",
          width: 150,
          minWidth: 150,
          fixed: "left",
          classes: "cell-style tight",
          component: "fltl-tasks",
        },
      ],
    };
  },
  mounted() {
    this.isLegacy = this.$store.settings.calendarLegacy;
  },
  beforeDestroy() {
    this.coreColumnDefs = [];
  },
  watch: {
    items() {
      setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
    },
  },
  computed: {
    defaultColorStylesDisabled() {
      return this.getSettings("calendarDefaultColorStylesDisabled", false);
    },
    hasValidColumns() {
      return this.columnDefs.length > 0;
    },
    columnOptions() {
      return {
        hubId: this.hubId,
        opsDisplay: this.calendarOpsDisplay,
        curApptDate: this.curApptDate,
        splitStr: this.splitStr,
      };
    },
    curApptDate() {
      return /\d{4}-\d{2}-\d{2}/.test(this.mark) ? this.mark : null;
    },
    calendarOpsDisplay() {
      return this.getSettings("calendarOpsDisplay", "default");
    },
    columnsToHideByMark() {
      return {
        upcoming_loads: [
          "operations",
          "route_est",
          "route_status",
          "instructions",
          "ar",
          "ap",
          "profit",
        ],
      };
    },
    columnDefs() {
      const columns = this.coreColumnDefs.filter(
        (o) => o.legacy == null || o.legacy == this.isLegacy,
      );
      const columnsToHide = this.columnsToHideByMark[this.mark] || [];
      return columns.filter((o) => !columnsToHide.includes(o.key));
    },
    layout() {
      return this.$store.layouts.calendar || {};
    },
    maxHeight() {
      return this.virtual ? "calc(100vh - 155px)" : "auto";
    },
    bufferScale() {
      if (this.items.length < 25) {
        return Math.max(1, Math.round(this.items.length / 15));
      } else {
        return Math.max(1, Math.round(this.items.length / 25));
      }
    },
  },
  methods: {
    getHeight() {
      const el = document.querySelector("#container-on-calendar");
      return el ? el.offsetHeight - 105 : 0;
    },
    rowClass({ row }) {
      let rowStyles = {};
      if (row.color) rowStyles[`row-${row.color}`] = true;
      if (!row.color && !this.isBroker) rowStyles.brokered = row.brokered;
      if (
        this.layout.color_styles &&
        !this.defaultColorStylesDisabled &&
        !row.color &&
        row.mission
      ) {
        rowStyles[row.mission] = true;
      }
      return rowStyles;
    },
    cellClass({ row, column, rowIndex }) {
      if (column.label == "TRLR/CONT.#") return `cell-${row.type_color}`;
    },
    columnEvent(fn, ...args) {
      this[fn](...args);
    },

    autoSave(item, column, value) {
      let params = { type: item.type, column, value };
      this.$http
        .put(`/api/v1/attrs/${item.id}`, params)
        .then((response) => {
          this.$message({
            message: "It was changed successfully",
            type: "success",
          });
          if (column == "weight") {
            this.checkTriaxle(item);
          }
        })
        .catch((err) => {
          this.$message({ message: err.response.data.errors, type: "error" });
        });
    },

    handleCellClick(event) {
      // Find the closest element with data-action attribute
      let target = event.target;
      let action = target.getAttribute("data-action");
      let orderId = target.getAttribute("data-order-id");

      // If the clicked element doesn't have data attributes, look up the DOM tree
      while (target && !action) {
        target = target.parentElement;
        if (target) {
          action = target.getAttribute("data-action");
          orderId = target.getAttribute("data-order-id");
        }
      }

      if (!action) return;

      event.preventDefault();
      event.stopPropagation();

      // Route to appropriate method based on action
      switch (action) {
        case "viewOrder":
          this.viewOrder(orderId);
          break;
        case "showReceivable":
          this.showReceivable(orderId);
          break;
        case "showPayable":
          this.showPayable(orderId);
          break;
        case "showBOL":
          const bolId = target.getAttribute("data-bol-id");
          this.showBOL(bolId);
          break;
        default:
          console.warn("Unknown action:", action);
      }
    },

    viewOrder(orderId) {
      Dialog.open({
        width: "900px",
        clickToClose: true,
        title: "Container: " + orderId,
        url: "/containers/" + orderId,
      });
    },

    showReceivable(orderId) {
      Dialog.open({
        width: "720px",
        height: "auto",
        pivotY: 0.5,
        clickToClose: true,
        title: "Container: " + orderId,
        url: "/containers/" + orderId + "/receivable_charges",
      });
    },

    showPayable(orderId) {
      Dialog.open({
        width: "720px",
        height: "auto",
        pivotY: 0.5,
        clickToClose: true,
        title: "Container: " + orderId,
        url: "/containers/" + orderId + "/payable_charges",
      });
    },

    showBOL(bolId) {
      Dialog.open({
        width: "960px",
        pivotY: 0,
        resizable: false,
        title: "BOL: " + bolId,
        url: "/bols/" + bolId,
      });
    },
  },
};
</script>

<style lang="scss">
.cal-fltl-table {
  @apply clear-both p-0 mx-auto overflow-hidden;
}
</style>
